import React, { useEffect, useState, createContext, useContext } from 'react';
import { X } from 'lucide-react';
interface ToastProps {
  message: string;
  type: 'success' | 'error' | 'info';
  id: number;
}
interface ToastContextType {
  toast: (message: string, type?: 'success' | 'error' | 'info') => void;
}
const ToastContext = createContext<ToastContextType | undefined>(undefined);
export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};
export const ToastProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const [toasts, setToasts] = useState<ToastProps[]>([]);
  const toast = (message: string, type: 'success' | 'error' | 'info' = 'success') => {
    const id = Date.now();
    setToasts(prevToasts => [...prevToasts, {
      message,
      type,
      id
    }]);
    // Auto-remove after 5 seconds
    setTimeout(() => {
      setToasts(prevToasts => prevToasts.filter(toast => toast.id !== id));
    }, 5000);
  };
  const removeToast = (id: number) => {
    setToasts(prevToasts => prevToasts.filter(toast => toast.id !== id));
  };
  return <ToastContext.Provider value={{
    toast
  }} data-id="element-2393">
      {children}
      <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2" data-id="element-2394">
        {toasts.map(toast => <div key={toast.id} className={`p-3 rounded-lg shadow-lg flex items-center justify-between max-w-sm ${toast.type === 'success' ? 'bg-emerald-600 text-white' : toast.type === 'error' ? 'bg-red-600 text-white' : 'bg-blue-600 text-white'}`} data-id="element-2395">
            <span data-id="element-2396">{toast.message}</span>
            <button onClick={() => removeToast(toast.id)} className="ml-2 p-1 rounded-full hover:bg-white/10" data-id="element-2397">
              <X className="w-4 h-4" data-id="element-2398" />
            </button>
          </div>)}
      </div>
    </ToastContext.Provider>;
};